import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import GoogleMapReact from 'google-map-react'

import { fetchAffiliateMessages, affiliateMessagesDataChange,
	submitAffiliateMessage, userAffiliateMetaChange } from '../actions/acUserAffiliate'

import ModalLayout from './shared/ModalLayout'
import { PootsyTitle, MapMarker, PrimaryLink } from './DesignFunctions'
import { PootsyTextArea } from './InputsFunctions'
import TimelineLayout from './TimelineLayout'

import { womanAvatar, manAvatar } from '../static/svg/avatars'
import defaultAffiliateLogo from '../static/img/default-affiliate-logo.png'

const defaultMapCenter = { lat: 50.845, lng: 4.354 } // < defaults to centering on brussels
class UserAffiliate extends Component {
	state = {
		showImageModal: false,
		modalImageUrl: ""
	}
	componentWillMount = () => {
		let { match } = this.props
		this.fetchAffiliate(match.params.id)
	}
	componentWillReceiveProps = newProps => {
		if(this.props.match.params.id !== newProps.match.params.id){
			this.fetchAffiliate(newProps.match.params.id)
		}
	}
	fetchAffiliate = id => {
		this.props.dispatch(userAffiliateMetaChange({ selectedAffiliateID: id }))
		this.props.dispatch(fetchAffiliateMessages())
	}
	handleAffiliateMessageChange = e => {
		this.props.dispatch(affiliateMessagesDataChange({ message: e.target.value }))
	}
	handleSubmit = e => {
		if(e.key === 'Enter'){ this.props.dispatch(submitAffiliateMessage()) }
	}
	showImage = e => {
		let { imgurl } = e.target.dataset
		this.setState({ showImageModal: true, modalImageUrl: imgurl })
	}
	closeImageModal = () => {
		this.setState({ showImageModal: false, modalImageUrl: "" })
	}
	renderDetails = booking => {
		let { t } = this.context
		let { affiliates, meta } = this.props
		let affiliate = affiliates.find(aff => aff.id === meta.selectedAffiliateID)
		const rightInfos = [
			{ label: t('phone'),   value: affiliate.phone },
			{ label: t('email'),   value: affiliate.email },
			{ label: t('address'), value: affiliate.address.inline },
			{ label: t('website'), value: <PrimaryLink to={"/affiliate-page/"+affiliate.id} label={affiliate.name}/> },
		]
		return rightInfos.map(entry =>
			<div key={entry.label} className="detail">
				<div className="label">{entry.label}</div>
				<div className="value">{entry.value}</div>
			</div>
		)
	}
	renderMessageContent = mess => {
		let { user, affiliates, meta } = this.props
		let affiliate = affiliates.find(aff => aff.id === meta.selectedAffiliateID)
		let leftPart, sender
		if(mess.sender === 'affiliate') {
			leftPart = <img className="logo" alt="logo" src={affiliate.logo}/>
			sender = affiliate.name
		} else {
			leftPart = <div className="profile-pic">{user.title === 'mr' ? manAvatar : womanAvatar}</div>
			sender = user.firstName + " " + user.lastName
		}
		return (
			<div className="user-affiliate-message">
				<div className="header customer">
					{leftPart}
					<div className="message-infos">
						<div className="sender">{sender}</div>
						<div className="datetime">{mess.createdAt.format('HH:mm')}</div>
					</div>
				</div>
				<div className="message">
					{mess.content}
					<div className="images">
						{mess.images.map(img =>
							<img alt="mess-img" key={img} src={img} data-imgurl={img} onClick={this.showImage}/>
						)}
					</div>
				</div>
			</div>
		)
	}
	render() {
		let { t } = this.context
		let { showImageModal, modalImageUrl } = this.state
		let { meta, form, messages, affiliates } = this.props
		let affiliate = affiliates.find(aff => aff.id === meta.selectedAffiliateID) || {}
		return(
			<div className="UserAffiliate">
				<div className="left">
					{showImageModal &&
						<ModalLayout customClass="user-affiliate-image-modal" contentClass="img-container" closeModal={this.closeImageModal}>
							<img alt="i" src={modalImageUrl}/>
						</ModalLayout>
					}
					<PootsyTitle title={affiliate.name}/>
					<PootsyTextArea
						placeholder={t('affiliate_chat_prompt')}
						value={form.message}
						onChange={this.handleAffiliateMessageChange}
						onKeyPress={this.handleSubmit}
					/>
					<TimelineLayout timelineItems={messages.reduceRight((acc, mess) => {
						acc.push({ reactKey: mess.createdAt, date: mess.createdAt, content: this.renderMessageContent(mess) })
						return acc
					}, [])}/>
				</div>
				<div className="right">
					<div className="affiliate-info-box">
						<div className="top-section">
							<img alt="logo" className="logo" src={affiliate.logo || defaultAffiliateLogo}/>
						</div>
						<div className="details">
							{this.renderDetails()}
						</div>
						{affiliate.address && affiliate.address.lat &&
							<div className="maps-container">
									<GoogleMapReact
										zoom={13}
										defaultCenter={defaultMapCenter} // ( defined at top of file, otherwise there is a warning at each render because of redefining the variable )
										center={{ lat: affiliate.address.lat, lng: affiliate.address.lng }}
										bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_API_KEY }}
									>
										<MapMarker lat={affiliate.address.lat} lng={affiliate.address.lng}/>
									</GoogleMapReact>
							</div>
						}
						<div className="contract-start">
						</div>
					</div>
				</div>
			</div>
		)
	}
}

UserAffiliate.contextTypes = { t: PropTypes.func }
const mapStateToProps = state => ({
	user: state.dataReducer.currentUser,
	form: state.dataReducer.affiliateMessagesForm,
	messages: state.dataReducer.affiliateMessages,
	currentMessage: state.dataReducer.currentAffiliateMessage,
	meta: state.metadataReducer.userAffiliate,
	affiliates: state.dataReducer.userAffiliates,
})
export default connect(mapStateToProps)(UserAffiliate);



// WEBPACK FOOTER //
// ./src/components/UserAffiliate.js